export default {
  setWorkers: (state, workers) => {
    state.workers = workers;
  },
  addWorkers: (state, workers) => {
    state.workers = state.workers.concat(workers);
  },

  updateWorkerOnSiteStatus: (state, {onsite, onsite_since}) => {
    state.worker.onsite = onsite
    state.worker.onsite_since = onsite_since
  },

  clearWorkerPhoneRegistration: (state) => {
    if (state.worker?.phone_platform) {
      state.worker.phone_platform = null
    }
  },
  
  setWorker: (state, worker) => {
    if (null === worker) {
      state.worker = null;
      return;
    }
    worker.dictMap = {};

    worker.dictionary.forEach(dict => {
      if (!worker.dictMap.hasOwnProperty(dict.type)) {
        worker.dictMap[dict.type] = [];
      }

      worker.dictMap[dict.type].push(dict.value);
    });

    state.worker = worker;
  },
  setLinks: (state, links) => {
    state.links = links;
  },

  setMeta: (state, meta) => {
    state.meta = meta;
  },

  toggleData: state => {
    state.hasData = true;
  },
};
